import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {RetryableError} from 'shells/flash-banner/retryable-error';
import {MessageContainer} from 'shells/message/message-container';
import {MarketingHeader} from 'shells/typography/marketing-header';

import {GetTaskSync} from './get-task-sync';
import {TasksSyncSettings} from './tasks-sync-settings';

import styles from './tasks-page.module.css';

const BULLETS = [
    'Assign tasks to any user, and associate any person, company, or lead in Nutshell to display that task on the page.',
    'Looking for automated tasks for you or your reps? Create preconfigured tasks with Nutshell’s sales automation so that your team is always focused on the right things.',
    'Want to stay in touch with an important contact? Set up recurring tasks so you’ll never drop the ball with a follow-up message.',
];

export function TasksPage() {
    const [errorMessages, setErrorMessages] = React.useState<string[]>([]);

    return (
        <div className={styles.container}>
            <MessageContainer>
                {errorMessages.map((message) => (
                    <FlashBanner
                        key={message}
                        hasBorder={true}
                        type='error'
                        onHidden={() => {
                            setErrorMessages(errorMessages.filter((msg) => msg !== message));
                        }}
                    >
                        {message}
                    </FlashBanner>
                ))}
            </MessageContainer>
            <MarketingHeader>Powerful task system, all built into Nutshell</MarketingHeader>
            <BulletedList size='big' bullets={BULLETS} />
            <GetTaskSync>
                {/* @ts-expect-error */}
                {({isLoading, taskSync, refetch, errorMessage}) => {
                    if (isLoading) {
                        return null;
                    }

                    if (errorMessage) {
                        return (
                            <RetryableError
                                message='There was a problem getting your task sync settings. Please retry or contact
                                    support.'
                                details={errorMessage}
                                retry={refetch}
                            />
                        );
                    }

                    return (
                        <div className={styles['inner-container']}>
                            <TasksSyncSettings
                                errorMessages={errorMessages}
                                setErrorMessages={setErrorMessages}
                                tasksSync={taskSync}
                                refetchTaskSync={refetch}
                            />
                        </div>
                    );
                }}
            </GetTaskSync>
        </div>
    );
}
